import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import VolumePicker from '../components/session/VolumePicker.svelte';
import SegmentedControl from '../components/shared/SegmentedControl.svelte';
import Button from '../components/shared/Button.svelte';
import { saveSession } from '../lib/services/session';
import { getSettings } from '../lib/stores/settings.svelte.ts';
import { getActiveChild } from '../lib/stores/children.svelte.ts';
import { getInventoryByLocation, useFromStorage } from '../lib/services/storage';
import { navigate } from '../lib/router.svelte.ts';
import { mlToOz, ozToMl, formatVolume } from '../lib/utils/units.ts';
import { showToast } from '../components/shared/Toast.svelte';

var root_2 = $.from_html(`<p class="inventory-empty svelte-1o0xl8pn1xvsi"> </p>`);
var root_4 = $.from_html(`<button><span class="inventory-date svelte-1o0xl8pn1xvsi"> </span> <span class="inventory-vol svelte-1o0xl8pn1xvsi"> </span></button>`);
var root_3 = $.from_html(`<div class="inventory-list svelte-1o0xl8pn1xvsi"></div>`);
var root_1 = $.from_html(`<div class="form-section svelte-1o0xl8pn1xvsi"><h3 class="svelte-1o0xl8pn1xvsi">Storage batch</h3> <!></div>`);
var root_5 = $.from_html(`<button class="note-toggle svelte-1o0xl8pn1xvsi">+ Add note</button>`);
var root_6 = $.from_html(`<textarea class="note-input svelte-1o0xl8pn1xvsi" placeholder="Optional note..." rows="2"></textarea>`);
var root = $.from_html(`<!> <div class="session-page svelte-1o0xl8pn1xvsi"><div class="form-section svelte-1o0xl8pn1xvsi"><h3 class="svelte-1o0xl8pn1xvsi">How much?</h3> <!></div> <div class="form-section svelte-1o0xl8pn1xvsi"><h3 class="svelte-1o0xl8pn1xvsi">Source</h3> <!></div> <!> <div class="actions svelte-1o0xl8pn1xvsi"><!> <!></div></div>`, 1);

function BottleFeed($$anchor, $$props) {
	$.push($$props, true);

	const sources = [
		{ value: 'fresh', label: 'Fresh' },
		{ value: 'fridge', label: 'Fridge' },
		{ value: 'freezer', label: 'Freezer' },
		{ value: 'formula', label: 'Formula' }
	];

	const settings = $.derived(getSettings);
	const activeChild = $.derived(getActiveChild);
	const isImperial = $.derived(() => $.get(settings).units === 'imperial');

	// Internal volume always in mL — pre-fill from active child's last bottle volume
	let volumeMl = $.state(60);

	const displayVolume = $.derived(() => $.get(isImperial) ? mlToOz($.get(volumeMl)) : $.get(volumeMl));

	$.user_effect(() => {
		if ($.get(activeChild)?.lastBottleVolume) {
			$.set(volumeMl, $.get(activeChild).lastBottleVolume, true);
		}
	});

	function handleVolumeChange(v) {
		$.set(volumeMl, $.get(isImperial) ? ozToMl(v) : v, true);
	}

	let source = $.state('fresh');
	let note = $.state('');
	let showNote = $.state(false);

	// Inventory for fridge/freezer sources
	let inventoryEntries = $.state($.proxy([]));

	let selectedEntryId = $.state(null);
	const needsInventory = $.derived(() => $.get(source) === 'fridge' || $.get(source) === 'freezer');

	$.user_effect(() => {
		if ($.get(needsInventory) && $.get(activeChild)) {
			loadInventory();
		} else {
			$.set(inventoryEntries, [], true);
			$.set(selectedEntryId, null);
		}
	});

	async function loadInventory() {
		if (!$.get(activeChild)) return;

		$.set(inventoryEntries, await getInventoryByLocation($.get(activeChild).id, $.get(source)), true);
		$.set(selectedEntryId, $.get(inventoryEntries).length > 0 ? $.get(inventoryEntries)[0].id : null, true);
	}

	async function handleSave() {
		if (!$.get(activeChild)) {
			showToast('No active child selected.', 'error');

			return;
		}

		// Detect storage/inventory mismatches before saving so we can surface them
		// after the save succeeds. We still allow the save — caregivers often log
		// the bottle before catching up the storage panel.
		let warning = null;

		if ($.get(source) === 'fridge' || $.get(source) === 'freezer') {
			if ($.get(inventoryEntries).length === 0) {
				warning = `No ${$.get(source)} stock found — saved without updating inventory.`;
			} else if ($.get(selectedEntryId)) {
				const selectedEntry = $.get(inventoryEntries).find((e) => e.id === $.get(selectedEntryId));

				if (selectedEntry && selectedEntry.remainingVolumeMl < $.get(volumeMl)) {
					warning = `Selected ${$.get(source)} batch only had ${formatVolume(selectedEntry.remainingVolumeMl, $.get(isImperial))} — saved anyway.`;
				}
			}
		}

		try {
			const now = Date.now();

			await saveSession($.get(activeChild).id, {
				type: 'bottle',
				startTime: now,
				endTime: now,
				durationMs: 0,
				volumeMl: $.get(volumeMl),
				source: $.get(source),
				storageEntryId: $.get(selectedEntryId) || undefined,
				note: $.get(note) || undefined
			});

			// Decrement the chosen storage entry
			if ($.get(selectedEntryId)) {
				await useFromStorage($.get(selectedEntryId), $.get(volumeMl));
			}

			if (warning) {
				showToast(warning, 'warning');
			}

			navigate('/');
		} catch(e) {
			showToast('Failed to save session. Please try again.', 'error');
		}
	}

	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, { title: 'Bottle Feed', showBack: true, backPath: '/log' });

	var div = $.sibling(node, 2);
	var div_1 = $.child(div);
	var node_1 = $.sibling($.child(div_1), 2);

	{
		let $0 = $.derived(() => $.get(isImperial) ? 'oz' : 'mL');
		let $1 = $.derived(() => $.get(isImperial) ? 0.5 : 5);
		let $2 = $.derived(() => $.get(isImperial) ? 17 : 500);

		VolumePicker(node_1, {
			get value() {
				return $.get(displayVolume);
			},
			onchange: handleVolumeChange,
			get unit() {
				return $.get($0);
			},

			get step() {
				return $.get($1);
			},

			get max() {
				return $.get($2);
			}
		});
	}

	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var node_2 = $.sibling($.child(div_2), 2);

	SegmentedControl(node_2, {
		get options() {
			return sources;
		},

		get selected() {
			return $.get(source);
		},
		onchange: (v) => $.set(source, v, true)
	});

	$.reset(div_2);

	var node_3 = $.sibling(div_2, 2);

	{
		var consequent_1 = ($$anchor) => {
			var div_3 = root_1();
			var node_4 = $.sibling($.child(div_3), 2);

			{
				var consequent = ($$anchor) => {
					var p = root_2();
					var text = $.child(p);

					$.reset(p);
					$.template_effect(() => $.set_text(text, `No ${$.get(source) ?? ''} stock found. Volume will still be logged.`));
					$.append($$anchor, p);
				};

				var alternate = ($$anchor) => {
					var div_4 = root_3();

					$.each(div_4, 21, () => $.get(inventoryEntries), (entry) => entry.id, ($$anchor, entry) => {
						var button = root_4();
						let classes;
						var span = $.child(button);
						var text_1 = $.child(span, true);

						$.reset(span);

						var span_1 = $.sibling(span, 2);
						var text_2 = $.child(span_1, true);

						$.reset(span_1);
						$.reset(button);

						$.template_effect(
							($0, $1) => {
								classes = $.set_class(button, 1, 'inventory-item svelte-1o0xl8pn1xvsi', null, classes, { selected: $.get(selectedEntryId) === $.get(entry).id });
								$.set_text(text_1, $0);
								$.set_text(text_2, $1);
							},
							[
								() => new Date($.get(entry).storedAt).toLocaleDateString(),
								() => formatVolume($.get(entry).remainingVolumeMl, $.get(isImperial))
							]
						);

						$.delegated('click', button, () => $.set(selectedEntryId, $.get(entry).id, true));
						$.append($$anchor, button);
					});

					$.reset(div_4);
					$.append($$anchor, div_4);
				};

				$.if(node_4, ($$render) => {
					if ($.get(inventoryEntries).length === 0) $$render(consequent); else $$render(alternate, -1);
				});
			}

			$.reset(div_3);
			$.append($$anchor, div_3);
		};

		$.if(node_3, ($$render) => {
			if ($.get(needsInventory)) $$render(consequent_1);
		});
	}

	var div_5 = $.sibling(node_3, 2);
	var node_5 = $.child(div_5);

	{
		var consequent_2 = ($$anchor) => {
			var button_1 = root_5();

			$.delegated('click', button_1, () => $.set(showNote, true));
			$.append($$anchor, button_1);
		};

		var alternate_1 = ($$anchor) => {
			var textarea = root_6();

			$.remove_textarea_child(textarea);
			$.bind_value(textarea, () => $.get(note), ($$value) => $.set(note, $$value));
			$.append($$anchor, textarea);
		};

		$.if(node_5, ($$render) => {
			if (!$.get(showNote)) $$render(consequent_2); else $$render(alternate_1, -1);
		});
	}

	var node_6 = $.sibling(node_5, 2);

	Button(node_6, {
		variant: 'primary',
		size: 'lg',
		fullWidth: true,
		onclick: handleSave,
		children: ($$anchor, $$slotProps) => {
			$.next();

			var text_3 = $.text('Save');

			$.append($$anchor, text_3);
		},
		$$slots: { default: true }
	});

	$.reset(div_5);
	$.reset(div);
	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	BottleFeed = $.hmr(BottleFeed);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-1o0xl8pn1xvsi');
		BottleFeed[$.HMR].update(module.default);
	});
}

export default BottleFeed;

$.delegate(['click']);
import "bun-svelte:BottleFeed.svelte-1y3ma1g4wo449-style.css";